import { TextInput, Textarea, Stack, Switch } from "@mantine/core";
import { useForm } from "@mantine/form";
import { InsurancePlanType } from "../../../services/admin/insurance-plan-types.service";

export interface InsurancePlanTypeFormValues {
  type: string;
  description: string;
  isActive: boolean;
}

interface InsurancePlanTypeFormProps {
  initialValues?: InsurancePlanType;
  onSubmit: (values: InsurancePlanTypeFormValues) => void;
}

export default function InsurancePlanTypeForm({
  initialValues,
  onSubmit,
}: InsurancePlanTypeFormProps) {
  const form = useForm<InsurancePlanTypeFormValues>({
    initialValues: {
      type: initialValues?.type || "",
      description: initialValues?.description || "",
      isActive: initialValues?.isActive ?? true,
    },
    validate: {
      type: (value) => (!value ? "Plan type is required" : null),
    },
  });

  return (
    <form noValidate onSubmit={form.onSubmit(onSubmit)}>
      <Stack gap="md">
        <TextInput
          label="Plan Type"
          placeholder="e.g., PPO, HMO, EPO, POS, Medicare"
          required
          {...form.getInputProps("type")}
        />

        <Textarea
          label="Description"
          placeholder="Enter plan type description"
          minRows={3}
          {...form.getInputProps("description")}
        />

        <Switch
          label="Active"
          {...form.getInputProps("isActive", { type: "checkbox" })}
        />
      </Stack>
    </form>
  );
}

export { useForm } from "@mantine/form";
